import React, { useState } from 'react';
import { ChevronDown } from 'lucide-react';
import { motion, AnimatePresence } from 'framer-motion';
import { FadeIn } from './ui/FadeIn';
export function FAQ() {
  const faqs = [{
    q: '¿Es para principiantes?',
    a: 'Sí. Está diseñado para jugadores zurdos de nivel principiante a intermedio. No necesitás experiencia previa, solo ganas de mejorar tu zurda.'
  }, {
    q: '¿Necesito entrenador?',
    a: 'No. El sistema está diseñado para que puedas aplicarlo solo, en tu propio tiempo y a tu propio ritmo.'
  }, {
    q: '¿Cómo recibo el material?',
    a: 'Al instante después del pago recibís un email con acceso a todos los PDFs descargables.'
  }, {
    q: '¿Es un curso o un ebook?',
    a: 'Es un sistema completo de PDFs descargables. Sin videos, sin clases grabadas. Solo contenido que podés aplicar directamente en la cancha.'
  }, {
    q: '¿Cuánto tiempo tengo acceso?',
    a: 'Acceso de por vida. Una sola compra, contenido para siempre.'
  }, {
    q: '¿Puedo verlo desde el celular?',
    a: 'Sí. Todos los PDFs son compatibles con cualquier dispositivo: celular, tablet o computadora.'
  }];
  const [openIndex, setOpenIndex] = useState<number | null>(null);
  return <section className="py-16 bg-lightbg border-t border-gray-200" data-id="element-87">
      <div className="container mx-auto px-4 max-w-3xl" data-id="element-88">
        <FadeIn data-id="element-89">
          <h2 className="font-display text-3xl md:text-4xl font-black text-center mb-10 uppercase text-navy" data-id="element-90">
            Preguntas Frecuentes
          </h2>
        </FadeIn>

        <div className="space-y-3" data-id="element-91">
          {faqs.map((faq, idx) => <FadeIn key={idx} delay={idx * 0.05} data-id="element-92">
              <div className="bg-white border border-gray-200 rounded-xl overflow-hidden shadow-sm" data-id="element-93">
                <button onClick={() => setOpenIndex(openIndex === idx ? null : idx)} className="w-full px-6 py-4 flex items-center justify-between text-left font-bold text-navy hover:bg-gray-50 transition-colors focus:outline-none" data-id="element-94">
                  {faq.q}
                  <ChevronDown className={`w-5 h-5 text-celeste transition-transform duration-300 flex-shrink-0 ${openIndex === idx ? 'rotate-180' : ''}`} data-id="element-95" />
                </button>
                <AnimatePresence data-id="element-96">
                  {openIndex === idx && <motion.div initial={{
                height: 0,
                opacity: 0
              }} animate={{
                height: 'auto',
                opacity: 1
              }} exit={{
                height: 0,
                opacity: 0
              }} transition={{
                duration: 0.3
              }} data-id="element-97">
                      <div className="px-6 pb-5 text-gray-600" data-id="element-98">{faq.a}</div>
                    </motion.div>}
                </AnimatePresence>
              </div>
            </FadeIn>)}
        </div>
      </div>
    </section>;
}